var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('b-card',{staticClass:"bg-light text-dark",attrs:{"no-body":""}},[_c('b-card-body',[_c('h1',[_vm._v(_vm._s(_vm.$t('welcome')))]),_c('p',[_vm._v(_vm._s(_vm.$t('welcomeText')))])])],1),_c('dash-board-alerts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }